module.exports = __webpack_public_path__ + "img/img25.8b042f01.svg";